// Why a trip has its driver (API: App\Support\TripDriverSource, sent as
// trip.driver_source). Null on trips from before attribution.
const LABELS = {
    shift: "on shift",
    tag: "by driver tag",
    assigned: "vehicle's driver",
    manual: "set by hand",
    phone: "driver app",
};

export function driverSourceLabel(source) {
    return LABELS[source] ?? null;
}

// The BLE tag the tracker saw belongs to someone other than the trip's driver.
export function tagDisagrees(trip) {
    return trip?.detected_driver_id != null && trip.detected_driver_id !== trip.driver_id;
}
